<div class="acs__tag-row">
  <span class="acs__pulse acs__tag"></span>
  <span class="acs__pulse acs__rating"></span>
</div>

<div class="acs__title">
  <span class="acs__pulse acs__title-line acs__title-line--full"></span>
  <span class="acs__pulse acs__title-line acs__title-line--short"></span>
</div>

<div class="acs__desc">
  <span class="acs__pulse acs__desc-line"></span>
  <span class="acs__pulse acs__desc-line"></span>
  <span class="acs__pulse acs__desc-line acs__desc-line--short"></span>
</div>

<div class="acs__attrs">
  <span class="acs__pulse acs__attr"></span>
  <span class="acs__pulse acs__attr acs__attr--wide"></span>
  <span class="acs__pulse acs__attr"></span>
</div>

<div class="acs__sector-row">
  <span class="acs__pulse acs__sector"></span>
  <span class="acs__pulse acs__sector acs__sector--narrow"></span>
</div>

<div class="acs__footer">
  <div class="acs__stats">
    <span class="acs__pulse acs__stat"></span>
    <span class="acs__pulse acs__stat"></span>
  </div>
  <div class="acs__actions">
    <span class="acs__pulse acs__action-btn"></span>
    <span class="acs__pulse acs__action-btn"></span>
  </div>
</div>
